/**
 * Event
 */
export class Event {
    /**
     * Constructor
     * @param element html element
     * @param data data
     */
    constructor(element, data) {
        this.element = element;
        this.data = data;
    }
    /**
     * Gets element
     */
    getElement() {
        return this.element;
    }
    /**
     * Gets data
     */
    getData() {
        return this.data;
    }
}
//# sourceMappingURL=Event.js.map